module.exports = __webpack_public_path__ + "img/1659496575853-izin lokasi.png.6de3d6f8.webp";